import React from "react";
import { useParams } from "react-router-dom";
import { PageHero, DraftNotice } from "@/components/common/SectionHeading";

const CONTENT = {
    privacy: {
        title: "Privacy Policy",
        body: "LNL respects your privacy. Personal data submitted through inquiry and application forms is used solely for admissions and student-services purposes. Requests to access, correct or delete personal data may be sent to LNL Admissions.",
    },
    terms: {
        title: "Terms of Use",
        body: "By using this website, you agree to use its content and services responsibly. The information published here is provided in good faith. Requirements and details may be updated; please confirm the most recent information with LNL Admissions.",
    },
    accessibility: {
        title: "Accessibility Statement",
        body: "LNL aims to meet WCAG 2.1 AA standards. If you experience an accessibility issue on this website, please contact LNL Admissions so we can address it.",
    },
};

export default function Legal() {
    const { doc } = useParams();
    const c = CONTENT[doc] || CONTENT.privacy;
    return (
        <div data-testid={`legal-${doc}`}>
            <PageHero eyebrow="Legal" title={c.title} breadcrumbs={[{label:"Home",to:"/"},{label:c.title}]} />
            <section className="py-10 bg-white">
                <div className="lnl-container max-w-3xl">
                    <DraftNotice tone="warn">This text is provisional and marked "For Institutional and Legal Review."</DraftNotice>
                    <p className="mt-4 text-lnl-charcoal leading-relaxed">{c.body}</p>
                </div>
            </section>
        </div>
    );
}
